import {Component, OnInit} from '@angular/core';
import {LoginService} from './login.service';
import {Router} from '@angular/router';

declare var $: any;

@Component({
    selector: 'login',
    template: require('../../app/login/login.component.html'),
    styles: [require('../../app/login/login.component.css')]
})

export class LoginComponent implements OnInit {
    username = "";
    password = "";
    error = "";

    constructor(private loginService: LoginService, private router: Router) {
        if (this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword) {
            let link = ['/home'];
            this.router.navigate(link);
        }
        loginService.error.subscribe((error) => this.error = error);

        this.loginService.logIn.subscribe((mode) => {
            if (mode == true) {
                this.router.navigate(["/home"]);
            }
        });
    }

    ngOnInit() {
    }

    login() {
        this.loginService.login(this.username, this.password);
    }

    desplegarModal() {
        $("#modalRestablecerPass").modal("show");
    }

    restablecerPassword() {
        this.loginService.forgotPassword(this.username);
        $("#modalRestablecerPass").modal("hide");
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/login/login.component.ts